import { AVAuth } from "../Platform/AVAuth";
import { MediaStore } from "./MediaStore";
import { Loc } from "./Loc";
import { Server } from "../Platform/Server";
import ProfilePic from "../components/common/ProfilePicture";
export class Config
{

    public static async init ()
    {
        await Loc.SetLang();
        await MediaStore.init();
    }
    public static key : string = "LoveActavivo!";
}
